var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusCircle = function SvgPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    fillRule: "evenodd",
    d: "M2 9a7 7 0 1 0 14 0A7 7 0 0 0 2 9Zm7-9a9 9 0 1 0 0 18A9 9 0 0 0 9 0Zm0 5a1 1 0 0 1 1 1v2h2a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2H6a1 1 0 1 1 0-2h2V6a1 1 0 0 1 1-1Z",
    clipRule: "evenodd"
  })));
};
export default SvgPlusCircle;